module.exports = __webpack_public_path__ + "static/media/bus.e0019340.svg";